import {
  // Box,
  ChevronUp,
  // Edit,
  // Eye,
  // Filter,
  // GitMerge,
  PlusCircle,
  RotateCcw,
  // Sliders,
  // StopCircle,
  // Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react"; // ,{ useEffect, useState }
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
//   import Select from "react-select";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import moment from "moment";
import apiHandler from "../../common/api";
//   import { Download } from "react-feather";
const route = all_routes;

const Sales = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [salesList, setSalesList] = useState([]);

  const columns = [
    // {
    //   header: "ID",
    //   accessorKey: "id",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Created Date",
    //   accessorKey: "CreatedDate",
    //   enableSorting: true,
    //   sortingFn: "datetime",
    //   Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    // },
    // {
    //   header: "Updated Date",
    //   accessorKey: "UpdatedDate",
    //   enableSorting: true,
    //   sortingFn: "datetime",
    //   Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    // },
    {
      header: "Sale Order Item Code",
      accessorKey: "Sale_Order_Item_Code",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //   header: "Display Order Code",
    //   accessorKey: "Display_Order_Code",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    //   {
    //     header: "Reverse Pickup Code",
    //     accessorKey: "Reverse_Pickup_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Reverse Pickup Created Date",
    //     accessorKey: "Reverse_Pickup_Created_Date",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    //   },
    //   {
    //     header: "Reverse Pickup Reason",
    //     accessorKey: "Reverse_Pickup_Reason",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Notification Email",
    //     accessorKey: "Notification_Email",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Notification Mobile",
    //     accessorKey: "Notification_Mobile",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Require Customization",
    //     accessorKey: "Require_Customization",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "COD",
    //     accessorKey: "COD",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    //   },
    //   {
    //     header: "Shipping Address ID",
    //     accessorKey: "Shipping_Address_Id",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    {
      header: "Category",
      accessorKey: "Category",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Invoice Code",
      accessorKey: "Invoice_Code",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Invoice Created",
      accessorKey: "Invoice_Created",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ cell }) => moment(cell.getValue()).format("dd/MM/yyyy hh:mm:ss"), // .toLocaleDateString()
    },
    //   {
    //     header: "E-Way Bill No",
    //     accessorKey: "EWayBill_No",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "E-Way Bill Date",
    //     accessorKey: "EWayBill_Date",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ cell }) => cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : "-",
    //   },
    //   {
    //     header: "E-Way Bill Valid Till",
    //     accessorKey: "EWayBill_Valid_Till",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    //     Cell: ({ cell }) => cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : "-",
    //   },
    //   {
    //     header: "Shipping Address Name",
    //     accessorKey: "Shipping_Address_Name",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address Line 1",
    //     accessorKey: "Shipping_Address_Line_1",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address Line 2",
    //     accessorKey: "Shipping_Address_Line_2",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address City",
    //     accessorKey: "Shipping_Address_City",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address State",
    //     accessorKey: "Shipping_Address_State",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address Country",
    //     accessorKey: "Shipping_Address_Country",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Address Pincode",
    //     accessorKey: "Shipping_Address_Pincode",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Shipping Address Latitude",
    //     accessorKey: "Shipping_Address_Latitude",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Shipping Address Longitude",
    //     accessorKey: "Shipping_Address_Longitude",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Shipping Address Phone",
    //     accessorKey: "Shipping_Address_Phone",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address ID",
    //     accessorKey: "Billing_Address_Id",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address Name",
    //     accessorKey: "Billing_Address_Name",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address Line 1",
    //     accessorKey: "Billing_Address_Line_1",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address Line 2",
    //     accessorKey: "Billing_Address_Line_2",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address City",
    //     accessorKey: "Billing_Address_City",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address State",
    //     accessorKey: "Billing_Address_State",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address Country",
    //     accessorKey: "Billing_Address_Country",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Billing Address Pincode",
    //     accessorKey: "Billing_Address_Pincode",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Billing Address Latitude",
    //     accessorKey: "Billing_Address_Latitude",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Billing Address Longitude",
    //     accessorKey: "Billing_Address_Longitude",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Billing Address Phone",
    //     accessorKey: "Billing_Address_Phone",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Shipping Method",
    //     accessorKey: "Shipping_Method",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    {
      header: "Item SKU Code",
      accessorKey: "Item_SKU_Code",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    //   {
    //     header: "Channel Product ID",
    //     accessorKey: "Channel_Product_Id",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Item Type Name",
    //     accessorKey: "Item_Type_Name",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Item Type Color",
    //     accessorKey: "Item_Type_Color",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Item Type Size",
    //     accessorKey: "Item_Type_Size",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Item Type Brand",
    //     accessorKey: "Item_Type_Brand",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "Channel Name",
    //     accessorKey: "Channel_Name",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "SKU Require Customization",
    //     accessorKey: "SKU_Require_Customization",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Gift Wrap",
    //     accessorKey: "Gift_Wrap",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //   },
    //   {
    //     header: "Gift Message",
    //     accessorKey: "Gift_Message",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    //   {
    //     header: "HSN Code",
    //     accessorKey: "HSN_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    //   },
    {
      header: "MRP",
      accessorKey: "MRP",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    },
    //   {
    //     header: "Total Price",
    //     accessorKey: "Total_Price",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    //   },
    {
      header: "Selling Price",
      accessorKey: "Selling_Price",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    },
    // {
    //     header: "Cost Price",
    //     accessorKey: "Cost_Price",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    // },
    // {
    //     header: "Prepaid Amount",
    //     accessorKey: "Prepaid_Amount",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    // },
    // {
    //     header: "Subtotal",
    //     accessorKey: "Subtotal",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    // },
    // {
    //     header: "Discount",
    //     accessorKey: "Discount",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    //     Cell: ({ cell }) => `₹${parseFloat(cell.getValue()).toFixed(2)}`,
    // },
    // {
    //     header: "GST Tax Type Code",
    //     accessorKey: "GST_Tax_Type_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "CGST",
    //     accessorKey: "CGST",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "IGST",
    //     accessorKey: "IGST",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "SGST",
    //     accessorKey: "SGST",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "UTGST",
    //     accessorKey: "UTGST",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "CESS",
    //     accessorKey: "CESS",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "CGST Rate",
    //     accessorKey: "CGST_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "IGST Rate",
    //     accessorKey: "IGST_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "SGST Rate",
    //     accessorKey: "SGST_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "UTGST Rate",
    //     accessorKey: "UTGST_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "CESS Rate",
    //     accessorKey: "CESS_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "TCS Amount",
    //     accessorKey: "TCS_Amount",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Tax %",
    //     accessorKey: "Tax_Percentage",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Tax Value",
    //     accessorKey: "Tax_Value",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Voucher Code",
    //     accessorKey: "Voucher_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Charges",
    //     accessorKey: "Shipping_Charges",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Shipping Method Charges",
    //     accessorKey: "Shipping_Method_Charges",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "COD Service Charges",
    //     accessorKey: "COD_Service_Charges",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Gift Wrap Charges",
    //     accessorKey: "Gift_Wrap_Charges",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Packet Number",
    //     accessorKey: "Packet_Number",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Order Date (dd/MM/yyyy hh:MM:ss)",
    //     accessorKey: "Order_Date_as_dd/MM/yyyy_hh:MM:ss",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    {
      header: "Sale Order Code",
      accessorKey: "Sale_Order_Code",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //     header: "On Hold",
    //     accessorKey: "On_Hold",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    {
      header: "Sale Order Status",
      accessorKey: "Sale_Order_Status",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //     header: "Priority",
    //     accessorKey: "Priority",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Currency",
    //     accessorKey: "Currency",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Currency Conversion Rate",
    //     accessorKey: "Currency_Conversion_Rate",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Sale Order Item Status",
    //     accessorKey: "Sale_Order_Item_Status",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Cancellation Reason",
    //     accessorKey: "Cancellation_Reason",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Provider",
    //     accessorKey: "Shipping_provider",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Courier",
    //     accessorKey: "Shipping_Courier",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Arranged By",
    //     accessorKey: "Shipping_Arranged_By",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Package Code",
    //     accessorKey: "Shipping_Package_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Package Creation Date",
    //     accessorKey: "Shipping_Package_Creation_Date",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    // {
    //     header: "Shipping Package Status Code",
    //     accessorKey: "Shipping_Package_Status_Code",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Shipping Package Type",
    //     accessorKey: "Shipping_Package_Type",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Length (mm)",
    //     accessorKey: "Length_mm",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Width (mm)",
    //     accessorKey: "Width_mm",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Height (mm)",
    //     accessorKey: "Height_mm",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "Delivery Time",
    //     accessorKey: "Delivery_Time",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    // {
    //     header: "Tracking Number",
    //     accessorKey: "Tracking_Number",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Dispatch Date",
    //     accessorKey: "Dispatch_Date",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    // {
    //     header: "Facility",
    //     accessorKey: "Facility",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Return Date",
    //     accessorKey: "Return_Date",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    // {
    //     header: "Return Reason",
    //     accessorKey: "Return_Reason",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Return Remarks",
    //     accessorKey: "Return_Remarks",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    {
      header: "Created",
      accessorKey: "Created",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ cell }) => moment(cell.getValue()).format("dd/MM/yyyy hh:mm:ss"), // .toLocaleDateString()
    },
    {
      header: "Updated",
      accessorKey: "Updated",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ cell }) => moment(cell.getValue()).format("dd/MM/yyyy hh:mm:ss"), // .toLocaleDateString()
    },
    // {
    //     header: "Combination Identifier",
    //     accessorKey: "Combination_Identifier",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Combination Description",
    //     accessorKey: "Combination_Description",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Transfer Price",
    //     accessorKey: "Transfer_Price",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    {
      header: "Item Code",
      accessorKey: "Item_Code",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //     header: "IMEI",
    //     accessorKey: "IMEI",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Weight",
    //     accessorKey: "Weight",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // },
    // {
    //     header: "GSTIN",
    //     accessorKey: "GSTIN",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Customer GSTIN",
    //     accessorKey: "Customer_GSTIN",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "TIN",
    //     accessorKey: "TIN",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Payment Instrument",
    //     accessorKey: "Payment_Instrument",
    //     enableSorting: true,
    //     sortingFn: "alphanumeric",
    // },
    // {
    //     header: "Fulfillment TAT",
    //     accessorKey: "Fulfillment_TAT",
    //     enableSorting: true,
    //     sortingFn: "datetime",
    // },
    // {
    //     header: "Adjustment In Selling Price",
    //     accessorKey: "Adjustment_In_Selling_Price",
    //     enableSorting: true,
    //     sortingFn: "numeric",
    // }, {
    //   header: "Adjustment In Discount",
    //   accessorKey: "Adjustment_In_Discount",
    //   enableSorting: true,
    //   sortingFn: "numeric",
    // },
    // {
    //   header: "Store Credit",
    //   accessorKey: "Store_Credit",
    //   enableSorting: true,
    //   sortingFn: "numeric",
    // },
    // {
    //   header: "IRN",
    //   accessorKey: "IRN",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Acknowledgement Number",
    //   accessorKey: "Acknowledgement_Number",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Bundle SKU Code Number",
    //   accessorKey: "Bundle_SKU_Code_Number",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "SKU Name",
    //   accessorKey: "SKU_Name",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Batch Code",
    //   accessorKey: "Batch_Code",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Vendor Batch Number",
    //   accessorKey: "Vendor_Batch_Number",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Seller SKU Code",
    //   accessorKey: "Seller_SKU_Code",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Item Type EAN",
    //   accessorKey: "Item_Type_EAN",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Shipping Courier Status",
    //   accessorKey: "Shipping_Courier_Status",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Shipping Tracking Status",
    //   accessorKey: "Shipping_Tracking_Status",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Item Seal ID",
    //   accessorKey: "Item_Seal_Id",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Parent Sale Order Code",
    //   accessorKey: "Parent_Sale_Order_Code",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Channel Shipping",
    //   accessorKey: "Channel_Shipping",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Item Details",
    //   accessorKey: "Item_Details",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
  ];

  console.log(salesList, "salesList p");
  //   console.log(dataSource, "salesList d");
  console.log(columns, "salesList c");

  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  // const toggleFilterVisibility = () => {
  //   setIsFilterVisible((prevVisibility) => !prevVisibility);
  // };

  // const options = [
  //   { value: "sortByDate", label: "Sort by Date" },
  //   { value: "140923", label: "14 09 23" },
  //   { value: "110923", label: "11 09 23" },
  // ];
  // const salesList = [
  //   { value: "choose", label: "Choose Product" },
  //   { value: "lenovo", label: "Lenovo 3rd Generation" },
  //   { value: "nike", label: "Nike Jordan" },
  // ];
  // const categorylist = [
  //   { value: "choose", label: "Choose Category" },
  //   { value: "laptop", label: "Laptop" },
  //   { value: "shoe", label: "Shoe" },
  // ];
  // const subcategorylist = [
  //   { value: "choose", label: "Choose Sub Category" },
  //   { value: "computers", label: "Computers" },
  //   { value: "fruits", label: "Fruits" },
  // ];
  // const brandlist = [
  //   { value: "all", label: "All Brand" },
  //   { value: "lenovo", label: "Lenovo" },
  //   { value: "nike", label: "Nike" },
  // ];
  // const price = [
  //   { value: "price", label: "Price" },
  //   { value: "12500", label: "$12,500.00" },
  //   { value: "13000", label: "$13,000.00" },
  // ];

  //   const columns = [
  //     {
  //       title: "Product",
  //       dataIndex: "product",
  //       render: (text, record) => (
  //         <span className="productimgname">
  //           <Link to="/profile" className="product-img stock-img">
  //             <ImageWithBasePath alt="" src={record.productImage} />
  //           </Link>
  //           <Link to="/profile">{text}</Link>
  //         </span>
  //       ),
  //       sorter: (a, b) => a.product.length - b.product.length,
  //     },
  //     {
  //       title: "SKU",
  //       dataIndex: "sku",
  //       sorter: (a, b) => a.sku.length - b.sku.length,
  //     },

  //     {
  //       title: "Category",
  //       dataIndex: "category",
  //       sorter: (a, b) => a.category.length - b.category.length,
  //     },

  //     {
  //       title: "Brand",
  //       dataIndex: "brand",
  //       sorter: (a, b) => a.brand.length - b.brand.length,
  //     },
  //     {
  //       title: "Price",
  //       dataIndex: "price",
  //       sorter: (a, b) => a.price.length - b.price.length,
  //     },
  //     {
  //       title: "Unit",
  //       dataIndex: "unit",
  //       sorter: (a, b) => a.unit.length - b.unit.length,
  //     },
  //     {
  //       title: "Qty",
  //       dataIndex: "qty",
  //       sorter: (a, b) => a.qty.length - b.qty.length,
  //     },

  //     {
  //       title: "Created By",
  //       dataIndex: "createdby",
  //       render: (text, record) => (
  //         <span className="userimgname">
  //           <Link to="/profile" className="product-img">
  //             <ImageWithBasePath alt="" src={record.img} />
  //           </Link>
  //           <Link to="/profile">{text}</Link>
  //         </span>
  //       ),
  //       sorter: (a, b) => a.createdby.length - b.createdby.length,
  //     },
  //     {
  //       title: "Action",
  //       dataIndex: "action",
  //       render: () => (
  //         <div className="action-table-data">
  //           <div className="edit-delete-action">
  //             <div className="input-block add-lists"></div>
  //             <Link className="me-2 p-2" to={route.productdetails}>
  //               <Eye className="feather-view" />
  //             </Link>
  //             <Link className="me-2 p-2" to={route.editproduct}>
  //               <Edit className="feather-edit" />
  //             </Link>
  //             <Link
  //               className="confirm-text p-2"
  //               to="#"
  //               onClick={showConfirmationAlert}
  //             >
  //               <Trash2 className="feather-trash-2" />
  //             </Link>
  //           </div>
  //         </div>
  //       ),
  //       sorter: (a, b) => a.createdby.length - b.createdby.length,
  //     },
  //   ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: "sales/saleslist",
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setSalesList(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Sales List</h4>
              <h6>Manage your Sales</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                    onClick={() => {
                      showConfirmationAlert();
                    }}
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderRefreshTooltip}
                onClick={prodcutDataListApi}
              >
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to={route.salessync} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Get Sales Sync
            </Link>
          </div>
          {/* <div className="page-btn import">
              <Link
                to="#"
                className="btn btn-added color"
                data-bs-toggle="modal"
                data-bs-target="#view-notes"
              >
                <Download className="me-2" />
                Import Product
              </Link>
            </div> */}
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            {/* <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
                <div className="form-sort">
                  <Sliders className="info-img" />
                  <Select
                    className="img-select"
                    classNamePrefix="react-select"
                    options={options}
                    placeholder="14 09 23"
                  />
                </div>
              </div> */}
            {/* /Filter */}
            {/* <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="row">
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Box className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={salesList}
                              placeholder="Choose Product"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={categorylist}
                              placeholder="Choose Category"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <GitMerge className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={subcategorylist}
                              placeholder="Choose Sub Category"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={brandlist}
                              placeholder="Nike"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <i className="fas fa-money-bill info-img" />
  
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={price}
                              placeholder="Price"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Link className="btn btn-filters ms-auto">
                              {" "}
                              <i
                                data-feather="search"
                                className="feather-search"
                              />{" "}
                              Search{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            {/* /Filter */}
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={salesList} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default Sales;
